module.exports = __webpack_public_path__ + "assets/scoober-logo-he-12ea59.svg";